import React, { FC, useCallback, useState } from 'react';
import { Button, IconButtonWrapper } from 'components/ui';
import { TooltipConfirm } from 'components';
import { t } from 'utils';
import styles from './FieldsInfo.module.scss';
import TooltipText from '../TooltipText/TooltipText';

export interface IFieldsInfo {
  title: string;
  id: string;
  secret?: string;
  hasGenerateButton?: boolean;
  onGenerate?: any;
}

const FieldsInfo: FC<IFieldsInfo> = (props) => {
  const { id, title, secret, hasGenerateButton, onGenerate } = props;
  const secretValue = secret ?? '************';
  const [isShowId, setIsShowId] = useState(false);
  const [isShowSecret, setIsShowSecret] = useState(false);

  const handleTooltip = useCallback((tooltipSetState) => {
    tooltipSetState(true);
    setTimeout(() => tooltipSetState(false), 600);
  }, []);

  const handleCopy = useCallback(
    (id, e, tooltipSetState) => {
      e.stopPropagation();
      if (id) {
        navigator.clipboard.writeText(id)?.catch();
        handleTooltip(tooltipSetState);
      }
    },
    [handleTooltip]
  );

  return (
    <div className={styles.root}>
      <p className={styles.heading}>
        <span className={styles.title}>{t(title)}</span>
      </p>
      <p className={styles.field}>
        <span className={styles.fieldTitle}>{t('app.id')}</span>
        <span className={styles.fieldData}>{id}</span>
        <IconButtonWrapper
          className={styles.fieldButton}
          iconPrefix='far'
          icon='copy'
          onClick={(e) => handleCopy(id, e, setIsShowId)}
        />
        <TooltipText isShow={isShowId}>{t('fieldsInfo.copied')}</TooltipText>
      </p>
      <p className={styles.field}>
        <span className={styles.fieldTitle}>{t('secret')}</span>
        <span className={styles.fieldData}>{secretValue}</span>
        {secret && (
          <IconButtonWrapper
            className={styles.fieldButton}
            iconPrefix='far'
            icon='copy'
            onClick={(e) => handleCopy(secret, e, setIsShowSecret)}
          />
        )}
        <TooltipText isShow={isShowSecret}>{t('fieldsInfo.copied')}</TooltipText>
      </p>
      {hasGenerateButton && (
        <TooltipConfirm
          title='please.confirm'
          text='appSecret.newToken.text'
          confirmText='form.buttonText.continue'
          onConfirm={onGenerate}
        >
          <Button color='dark' variant='ghost' type='button' medium>
            {t('appSecret.newToken.button.label')}
          </Button>
        </TooltipConfirm>
      )}
    </div>
  );
};

export default FieldsInfo;
